<div class="card-header py-0 d-flex flex-row justify-content-start align-items-center gap-24">
  <div class="d-flex justify-content-start align-items-center gap-24">
    <button
      type="button"
      class="btn btn-secondary d-flex align-items-center gap-2"
      (click)="profileViewChange.emit(false)"
    >
      <i class="icon ic-arrow-left-20"></i>
      <span>Back</span>
    </button>

    <div class="divider"></div>
    <div class="profile-title">Shareholder Profile</div>
  </div>

  @if (showCompanyActions) {
    <div class="flex-grow-1 d-flex align-items-center justify-content-end">
      <div ngbDropdown class="dropdown">
        <button
          ngbDropdownToggle
          id="company-actions-dd"
          class="btn btn-primary d-flex align-items-center gap-2"
        >
          <span>Actions</span>
          <i class="icon ic-select-20"></i>
        </button>

        <div
          ngbDropdownMenu
          aria-labelledby="company-actions-dd"
          class="common-dropdown-menu"
        >
          <button ngbDropdownItem (click)="onCompanyChangePartyName()">
            <i class="icon ic-change-officer-name-20"></i>

            <div class="document">
              <div class="title">Change Shareholder Name</div>
              <div class="asic-form">Form 484A2</div>
            </div>
          </button>

          <button ngbDropdownItem (click)="onChangeOfficerAddress()">
            <i class="icon ic-change-address-20"></i>

            <div class="document">
              <div class="title">Change Shareholder Address</div>
              <div class="asic-form">Form 484A1</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  }
</div>

<div class="card-body">
  @for (holder of securityholder.holders; track $index) {
    @if ($index != 0) {
      <app-divider class="mb-4 mt-3"/>
    }

    <div class="details">
      <div class="details-item">
        <div class="title">Shareholder</div>
        <div class="d-flex align-items-center gap-2 prop">
          <i
            class="icon ic-asic-black-white-20 cursor-default"
            tooltipClass="tooltip-info"
            placement="top"
            container="body"
            [ngbTooltip]="securityholder.nonAsic ? 'non-ASIC' : 'ASIC'"
            [class]="{
              'bg-gray-600': securityholder.nonAsic,
              'bg-asic-blue': !securityholder.nonAsic
            }"
          ></i>

          <i
            class="icon"
            [class]="{
              'ic-my-account-16': holder.$type === IndividualHolderModel.$type,
              'ic-companies-16': holder.$type === CorporateHolderModel.$type
            }"
          ></i>

          @if (holder.$type === CorporateHolderModel.$type) {
            <a
              class="d-flex align-items-center gap-8"
              [routerLink]="(holder | as : CorporateHolderModel).entityId! ? ['/companies', (holder | as : CorporateHolderModel).entityId] : null"
            >
              <div>
                <div class="font-weight-500 font-size-14 line-height-20">
                  {{ holder.name }}
                </div>

                @if ((holder | as : CorporateHolderModel).entityData.entityNumber) {
                  <div class="font-weight-400 font-size-12 line-height-16 color-gray-700">
                    {{ (holder | as : CorporateHolderModel).entityData.entityNumber | acn }}
                  </div>
                }
              </div>

              <div [hidden]="!(holder | as : CorporateHolderModel).entityId">
                <i class="icon ic-eye-16"></i>
              </div>
            </a>
          } @else if (holder.$type === IndividualHolderModel.$type) {
            <div>
              <a
                class="d-flex align-items-center gap-8"
                [routerLink]="(holder | as : IndividualHolderModel).individualId ? ['/individuals', (holder | as : IndividualHolderModel).individualId] : null"
              >
                <div [class.changes-hidden]="!pendingButtonState">
                  @if (pendingButtonState
                  && (holder | as : IndividualHolderModel)?.previousIndividualData?.fullNameLabel
                  && (holder | as : IndividualHolderModel)?.previousIndividualData?.fullNameLabel !== holder.name) {
                    <div class="prop previous">
                      {{ (holder | as : IndividualHolderModel)?.previousIndividualData?.fullNameLabel }}
                    </div>
                    <div class="prop current">{{ holder.name }}</div>
                  } @else {
                    <div class="prop">
                      {{ holder.name | defaultValue }}
                    </div>
                  }
                </div>

                <div [hidden]="!(holder | as : IndividualHolderModel).individualId">
                  <i class="icon ic-eye-16"></i>
                </div>
              </a>
            </div>
          }
        </div>
      </div>

      <div class="details-item">
        <div class="title">Address</div>
        <div [class.changes-hidden]="!pendingButtonState">
          @if (holder.$type === IndividualHolderModel.$type) {
            @if (pendingButtonState
            && (holder | as : IndividualHolderModel)?.previousIndividualData?.address?.normalizedFullAddress
            && (holder | as : IndividualHolderModel)?.previousIndividualData?.address?.normalizedFullAddress
            !== (holder | as : IndividualHolderModel)?.individualData?.address?.normalizedFullAddress) {
              <div class="prop previous">
                {{ (holder | as : IndividualHolderModel)?.previousIndividualData?.address?.normalizedFullAddress | defaultValue }}
              </div>
              <div class="prop current">
                {{ (holder | as : IndividualHolderModel)?.individualData?.address?.normalizedFullAddress | defaultValue }}
              </div>
            } @else {
              <div class="prop">
                {{ (holder | as : IndividualHolderModel)?.individualData?.address?.normalizedFullAddress | defaultValue }}
              </div>
            }
          } @else if (holder.$type === CorporateHolderModel.$type) {
            {{ (holder | as : CorporateHolderModel).entityData.registeredAddress.normalizedFullAddress | defaultValue }}
          }
        </div>
      </div>

      <div class="details-item">
        <div class="title">Beneficially Owned</div>
        <div class="prop">
          <app-ag-yes-no-status [value]="holder.details.isBeneficialOwner"/>
        </div>
      </div>

      @if (!holder.details.isBeneficialOwner) {
        <div class="details-item">
          <div class="title">Beneficial Owner</div>
          <div class="prop">
            <app-beneficial-owner
              [details]="holder.details"
              [relationshipIds]="[holder.relationshipId]"
              [showOpenIcon]="true"
              (onDataSaved)="onDataSaved.emit()"
            />
          </div>
        </div>
      }

      @if (holder.$type == CorporateHolderModel.$type) {
        <div class="signatories">
          <div class="title">Authorised Signatories</div>
          <div class="prop">
            <app-auth-signatory
              tip="Add Authorised Signatories’ names separated by semicolon"
              [details]="holder.details"
              [holderName]="holder.name"
              [isPosted]="holder.isPosted"
              [relationshipId]="holder.relationshipId"
              (onDataSaved)="onDataSaved.emit()"
            />
          </div>
        </div>
      }
    </div>
  }
</div>

<div class="card-body pt-0">
  <app-list-grid-client-side
    [rowData]="securityholder.holdings.length ? [securityholder] : []"
    [colDefs]="colDefs"
    [suppressRowClickSelection]="true"
    [suppressCellFocus]="true"
  />
</div>
